import React from "react";
import { useQueryClient } from "@tanstack/react-query";
import { AuthVerificationTracker } from "./AuthVerificationTracker";

/**
 * Wrapper component that safely renders AuthVerificationTracker only when QueryClient is available
 */
export const SafeAuthVerificationTracker = () => {
  try {
    // Try to access the QueryClient context
    useQueryClient();
    // If we get here, QueryClient is available
    return <AuthVerificationTracker />;
  } catch (error) {
    // QueryClient is not available, render nothing
    console.warn("QueryClient not available for AuthVerificationTracker:", error);
    return null;
  }
};